import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function LoadingIndicator() {
  const { t } = useTranslation();
  const ellipsis = '.....';
  const delay = 200;
  const [currentEllipsis, setCurrentEllipsis] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex <= ellipsis.length) {
      setTimeout(() => {
        setCurrentEllipsis(ellipsis.slice(0, currentIndex));
        setCurrentIndex(currentIndex + 1);
      }, delay);
    } else {
      setCurrentIndex(0);
    }
  }, [currentIndex, delay, ellipsis]);

  return <Typography variant="h4">{`${t('loading')}${currentEllipsis}`}</Typography>;
}

export default LoadingIndicator;
